<h2 mat-dialog-title>
  {{ data.mode === 'create' ? 'Add Configuration' : 'Edit Configuration' }}
</h2>

<mat-dialog-content class="config-dialog-content">
  <mat-form-field appearance="outline">
    <mat-label>DC Type</mat-label>
    <input
      matInput
      maxlength="50"
      [(ngModel)]="values.dcType"
      [ngModelOptions]="{ standalone: true }"
      [disabled]="data.mode === 'edit'"
      required
    />
    <mat-hint align="end">{{ values.dcType.length }}/50</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Description</mat-label>
    <textarea
      matInput
      maxlength="200"
      rows="3"
      [(ngModel)]="values.description"
      [ngModelOptions]="{ standalone: true }"
    ></textarea>
    <mat-hint align="end">{{ values.description.length }}/200</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>SubType</mat-label>
    <input
      matInput
      maxlength="50"
      [(ngModel)]="values.subType"
      [ngModelOptions]="{ standalone: true }"
      [disabled]="data.mode === 'edit'"
      required
    />
    <mat-hint align="end">{{ values.subType.length }}/50</mat-hint>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="!allValid"
    (click)="submit()"
  >
    {{ data.mode === 'create' ? 'Create' : 'Save' }}
  </button>
</mat-dialog-actions>
